import baseApi from 'shared/api/baseApi';

import type { PromptSectionPermission } from './promptSections.api';

export interface SalesPromptRewriteSubProject {
  id: number;
  name: string;
  hasPrompt: boolean;
  hasAdvisor: boolean;
}

export interface SalesPromptRewriteMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface SalesPromptRewriteTurn {
  message: SalesPromptRewriteMessage;
  prompt: string | null;
  changelog: string | null;
  sections: {
    id: number;
    name: string;
    displayName: string;
    permission: PromptSectionPermission;
    currentValue: string;
    value: string;
  }[];
}

const salesPromptRewriteApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSalesPromptRewriteSubProjects: build.query<
      SalesPromptRewriteSubProject[],
      { masterProjectId: number; subProjectId?: number }
    >({
      query: ({ masterProjectId, subProjectId }) => ({
        url: `/backoffice/projects/${masterProjectId}/sales-prompt-rewrite`,
        method: 'GET',
        params: subProjectId ? { subProjectId } : undefined,
      }),
    }),
    sendSalesPromptRewriteTurn: build.mutation<
      SalesPromptRewriteTurn,
      { masterProjectId: number; subProjectId: number | null; messages: SalesPromptRewriteMessage[] }
    >({
      query: ({ masterProjectId, subProjectId, messages }) => ({
        url: `/backoffice/projects/${masterProjectId}/sales-prompt-rewrite`,
        method: 'POST',
        body: { subProjectId, messages },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetSalesPromptRewriteSubProjectsQuery, useSendSalesPromptRewriteTurnMutation } =
  salesPromptRewriteApi;

export default salesPromptRewriteApi;
